import { NotificationModel } from "./Notification.model";

export class Notification extends NotificationModel {
    // Add custom methods here
}
